
import DxfPolyline from './DxfPolyline';

export default class DxfGroup {
  constructor (polyline) {
    this.root = polyline;
    this.children = [];
  }

  add (polyline) {
    this.children.push(polyline);
  }

  replace (polyline) {
    this.children.push(this.root.clone());
    this.root = polyline;
  }

  contains (other) {
    return this.root.containsPolyline(other);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/dxf/DxfGroup.js